import { render, staticRenderFns } from "./SwotTableRow.vue?vue&type=template&id=407fdcb6&scoped=true"
import script from "./SwotTableRow.vue?vue&type=script&lang=js"
export * from "./SwotTableRow.vue?vue&type=script&lang=js"
import style0 from "./SwotTableRow.vue?vue&type=style&index=0&id=407fdcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fdcb6",
  null
  
)

export default component.exports